import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { requestPartnerAccess } from '../config/links';
import { colors, shared } from '../styles/theme';

function Restaurants() {
  return (
    <section className={css(styles.page)}>
      <p className={css(styles.eyebrow)}>Restaurants</p>
      <h1 className={css(styles.title)}>Bring your restaurant onto YaBatho.</h1>
      <p className={css(styles.copy)}>
        Restaurants can use YaBatho to receive orders, manage menus, update
        availability, and work with the delivery flow through one platform.
      </p>
      <button
        className={css(styles.primaryButton)}
        onClick={() => requestPartnerAccess('Restaurant partner')}
      >
        Request Restaurant Access
      </button>

      <div className={css(styles.grid)}>
        {[
          ['Outlet setup', 'Create and manage restaurant profile details, locations, and operating information.'],
          ['Menu management', 'Maintain menu items, categories, pricing, and item availability.'],
          ['Order handling', 'Accept, prepare, mark ready, and complete orders from the restaurant workflow.'],
          ['Finances', 'View restaurant payout information and support reconciliation workflows.'],
        ].map(([title, text]) => (
          <article className={css(styles.card)} key={title}>
            <h2 className={css(styles.cardTitle)}>{title}</h2>
            <p className={css(styles.cardText)}>{text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  page: {
    ...shared.navPage,
  },
  eyebrow: shared.eyebrow,
  title: {
    margin: '0 0 18px',
    color: colors.ink,
    fontSize: '3.2rem',
    fontWeight: '900',
    lineHeight: 1.05,
    maxWidth: '860px',
    '@media (max-width: 520px)': {
      fontSize: '2rem',
      lineHeight: 1.08,
    },
  },
  copy: {
    margin: '0 0 26px',
    color: colors.muted,
    fontSize: '1.06rem',
    lineHeight: 1.8,
    maxWidth: '820px',
    '@media (max-width: 520px)': {
      fontSize: '0.98rem',
      lineHeight: 1.65,
    },
  },
  primaryButton: shared.primaryButton,
  grid: {
    marginTop: '34px',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: '16px',

    '@media (max-width: 980px)': {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },

    '@media (max-width: 640px)': {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    padding: '24px',
    boxShadow: '0 10px 28px rgba(30, 30, 30, 0.05)',
  },
  cardTitle: {
    margin: '0 0 10px',
    color: colors.ink,
    fontSize: '1.16rem',
  },
  cardText: {
    margin: 0,
    color: colors.muted,
    lineHeight: 1.65,
  },
});

export default Restaurants;
